<template>
    <section class="hero is-fullheight is-medium is-bold">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column">
                        <div class="notification is-danger-light" v-if="has_error">
                            {{this.error}}
                        </div>
                        <article class="card">
                            <form class="card-content" @submit.prevent="login">
                                <img src="/img/logo.png">
                                <p class="control">
                                    <input class="input" type="email" v-model="email" placeholder="Email" required
                                           autofocus>
                                </p>
                                <p class="control">
                                    <input class="input" type="password" v-model="password" placeholder="Password"
                                           required>
                                </p>
                                <p class="control">
                                    <button class="button is-info is-medium is-fullwidth" v-bind:class="{'is-loading': submitting}">Login</button>
                                </p>
                            </form>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                email: '',
                password: '',
                error: '',
                has_error: false,
                submitting: false,
            }
        },
        methods: {
            login: function () {
                this.submitting = true;
                let email = this.email
                let password = this.password
                this.$store.dispatch('login', {email, password})
                    .then(() => this.$router.push('/dashboard'))
                    .catch(err =>
                        this.handleError(err))
            },
            handleError: function (err) {
                this.submitting = false;
                this.has_error = true
                if (err.response.status == "401") {
                    this.error = "Invalid Username or Password"
                } else {
                    this.error = "A server error has occurred please try again later."
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        border-radius: 10px;
    }

    .login-title {
        color: #0f81cc;
        font-size: 1.5rem;
    }

    .card-content p {
        margin: 10px;
    }

    .card-content img {
        max-height: 1.75rem;
    }

    .is-danger-light {
        border-color: #f14668;
        color: #cc0f35;
        background-color: #feecf0;
    }

    .column {
        max-width: 300px;
    }
</style>